'use client';

import React from 'react';
import { useResolvedBranch } from '@/components/SiteHostProvider';
import { buildBreadcrumbSchema } from '@/lib/seo/breadcrumb-schema';
import { serializeJsonLd } from '@/lib/seo/json-ld';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

interface BreadcrumbItemData {
  slug: string;
  name: string;
  href: string;
}

interface ProductBreadcrumbProps {
  items: BreadcrumbItemData[];
  productName: string;
  includeStructuredData?: boolean;
}

export default function ProductBreadcrumb({ items, productName, includeStructuredData = true }: ProductBreadcrumbProps) {
  // Публичный путь и филиал страницы: на поддомене филиала (BRANCH_ROUTING=host)
  // разметка должна ссылаться на его хост и путь без /geo/<code>.
  const { code: branchCode, publicPath: pathname } = useResolvedBranch();
  return (
    <>
    {includeStructuredData && pathname && (
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: serializeJsonLd(buildBreadcrumbSchema(items, productName, pathname, branchCode)),
      }} />
    )}
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => (
          <React.Fragment key={item.slug}>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <a href={item.href} title={item.name}>{item.name}</a>
              </BreadcrumbLink>
            </BreadcrumbItem>
            {index < items.length - 1 && <BreadcrumbSeparator />}
          </React.Fragment>
        ))}
        {items.length > 0 && <BreadcrumbSeparator />}
        <BreadcrumbItem>
          <BreadcrumbPage title={productName}>{productName}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
    </>
  );
}

